module.exports = __webpack_public_path__ + "img/news.f14daa0c.svg";